<template>
  <div v-loading="isLoading" class="comp-tree">
    <!-- <el-button class="slot-t-top" type="primary" size="small" @click="handleAddTop">添加顶级节点</el-button> -->
    <el-input class="selectInput" :placeholder="placeholder" v-model="filterText" size="small">
      <svg slot="suffix" class="icon" aria-hidden="true">
        <use xlink:href="#iconsearchicon" />
      </svg>
    </el-input>
    <el-scrollbar style="height: calc(100% - 32px)">
      <el-tree
      :ref="treeRef"
      :indent="indent"
      :accordion="accordion"
      :data="treeData"
      v-if="treeData.length>0"
      highlight-current
      :props="attributes"
      :current-node-key="defaultCurrentNodeKey"
      :node-key="nodeKey"
      :default-expanded-keys="expandedKeys"
      :filter-node-method="filterNode"
      :expand-on-click-node="expandOnClickNode"
      @node-click="handleNodeClick"
      @node-expand="handleNodeExpand"
      @node-collapse="handleNodeCollapse"
      @node-drop="handleDrop"
      :draggable="treeDraggable"
    >
      <div class="comp-tr-node" slot-scope="{ node, data }">
        <!-- 编辑状态 -->
        <template v-if="node.isEdit">
          <div @click.stop>
            <el-input
              v-model="data.name"
              :maxlength="nodeMaxLength"
              size="mini"
              :ref="nodeInput(data)"
              @blur.stop="handleInput(node, data)"
            ></el-input>
          </div>
        </template>

        <!-- 非编辑状态 -->
        <template v-else>
          <!-- 名称： 新增节点增加class（is-new） -->
          <span
            :class="[data[nodeKey] < NODE_ID_START ? 'is-new' : '', 'comp-tr-node--name']"
          >{{ node.label }}</span>
          <!-- 默认坐席分组不可编辑 -->
          <el-dropdown
            placement="bottom-start"
            v-if="checkStatusDropdown"
            class="comp-tr-node--btns"
          >
            <span class="el-dropdown-link">
              <i class="el-icon-more el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="data.parentId === null || data.parentId === ''">
                <el-tooltip class="item" effect="light" content="添加顶级节点" placement="right">
                  <el-button
                    type="text"
                    size="mini"
                    @click.stop="handleAddTop()"
                  >
                    <svg class="icon color-primary" aria-hidden="true">
                      <use xlink:href="#icontianjiawenjian" />
                    </svg>
                  </el-button>
                </el-tooltip>
              </el-dropdown-item>
              <el-dropdown-item v-if="data.id !== defaultHideNodeId && btnsStatus.add && node.level < MAX_LEVEL">
                <el-tooltip class="item" effect="light" content="添加子级节点" placement="right">
                  <el-button
                    type="text"
                    size="mini"
                    @click.stop="handleAdd(node, data)"
                  >
                    <svg class="icon color-primary" aria-hidden="true">
                      <use xlink:href="#icontianjia" />
                    </svg>
                  </el-button>
                </el-tooltip>
              </el-dropdown-item>
              <el-dropdown-item v-if="data.id !== defaultHideNodeId">
                <el-tooltip class="item" effect="light" content="编辑节点" placement="right">
                  <el-button
                    type="text"
                    size="mini"
                    @click.stop="handleEdit(node, data)"
                  >
                    <svg class="icon color-primary" aria-hidden="true">
                      <use xlink:href="#icontable-bianji" />
                    </svg>
                  </el-button>
                </el-tooltip>
              </el-dropdown-item>
              <el-dropdown-item v-if="data.id !== defaultHideNodeId">
                <el-tooltip class="item" effect="light" content="删除节点" placement="right">
                  <el-button
                    type="text"
                    size="mini"
                    @click.stop="handleDelete(node, data)"
                  >
                    <svg class="icon color-danger" aria-hidden="true">
                      <use xlink:href="#icontable-delete" />
                    </svg>
                  </el-button>
                </el-tooltip>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
    </el-tree>
    </el-scrollbar>
  </div>
</template>

<script>
/**
 * TODO 搜索编辑树还不完善，传值部分还需要优化，暂时不要使用！！！
 */
export default {
  name: 'TreeSearch',
  props: {
    /* treeRef 必传 */
    treeRef: {
      type: String,
      default: () => {
        return 'selectTree'
      }
    },
    /* 配置项 */
    attributes: {
      type: Object,
      default: () => {
        return {
          children: 'children',
          label: 'name'
        }
      }
    },
    /* 选项列表数据(树形结构的对象数组) */
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    /* 初始值 */
    value: {
      type: Number,
      default: () => {
        return null
      }
    },
    /* 自动收起 */
    accordion: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    placeholder: {
      type: String,
      default: () => {
        return '检索关键字'
      }
    },
    nodeKey: {
      type: String,
      default: () => {
        return 'id'
      }
    },
    nodeMaxLength: {
      type: Number,
      default: () => {
        return 8
      }
    },
    defaultHideNodeId: {
      type: String,
      default: () => {
        return ''
      }
    },
    /* 是否有编辑权限 */
    btnsStatus: {
      type: Object,
      default: () => {
        return {
          add: false,
          edit: false,
          delete: false
        }
      }
    },
    /* 展开的节点 */
    expandedKeys: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultCurrentNodeKey: {
      type: String,
      default: () => {
        return ''
      }
    },
    addNode: Function,
    deleteNode: Function,
    editNode: Function,
    moveNode: Function,
    getClickNode: Function,
    updateExpendNodes: Function
  },
  data() {
    return {
      treeData: [],
      filterText: '',
      valueId: this.value, // 初始值
      valueTitle: '',
      isLoading: false, // 是否加载
      MAX_LEVEL: 5, // 设定最大层级
      NODE_ID_START: 0, // 新增节点id，逐次递减
      startId: null,
      initParam: {
        // 新增参数
        name: '新增分组',
        parentId: 0,
        children: []
      },
      expandOnClickNode: true,
      indent: 5,
      checkedKey: '',
      treeDraggable: !!this.btnsStatus.move,
      nodeName: ''
    }
  },
  mounted() {
    this.treeData = JSON.parse(JSON.stringify(this.options))
    this.initHandle()
    this.checkedKey = this.defaultCurrentNodeKey ? this.defaultCurrentNodeKey : this.defaultHideNodeId
    // console.log('=========' + this.defaultCurrentNodeKey)
  },
  computed: {
    checkStatusDropdown() {
      let res = false
      if (this.btnsStatus.add || this.btnsStatus.edit || this.btnsStatus.delete) {
        res = true
      }
      return res
    }
  },
  methods: {
    // -----------搜索树------------------
    // 初始化值
    initHandle() {
      // 初始值
      this.startId = this.NODE_ID_START
    },
    nodeInput(data) {
      return this.treeRef + 'slotTreeInput' + data[this.nodeKey]
    },
    // 点击树选项
    handleNodeClick(_data, _node) {
      this.checkedKey = _data.id
      if (_data.editFlag && _data.editFlag === 'add') {
        // 临时的节点
      } else {
        this.getClickNode(_data) // 通知外层点击节点
      }
    },
    handleNodeExpand(_node) {
      const list = this.$store.state.user.curExpandedKeys
      list.push(_node.id)
      this.updateExpendNodes(list)
    },
    handleNodeCollapse(_node) {
      const list = this.$store.state.user.curExpandedKeys
      list.splice(this.expandedKeys.indexOf(_node.id), 1)
      this.updateExpendNodes(list)
    },
    filterNode(value, data) {
      if (!value) return true
      return data[this.attributes.label].indexOf(value) !== -1
    },
    // -----------编辑树------------------
    handleDelete(_node, _data) {
      // 删除节点
      // 判断是否存在子节点
      if (_data.children && _data.children.length !== 0) {
        this.$message.error('此节点有子级，不可删除！')
        return false
      } else {
        // 二次确认
        this.$confirm('是否删除此节点？', '', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning'
        })
          .then(() => {
            this.deleteNode(_node, _data) // 通知外层删除
          })
          .catch(() => {})
      }
    },
    // 修改节点
    handleInput(_node, _data) {
      this.treeDraggable = !!this.btnsStatus.move

      if (!_data.name || _data.name.trim() === '') {
        this.$message.error('节点名不能为空！')
        return false
      }
      // 退出编辑状态
      if (_data.editFlag && _data.editFlag === 'add') {
        this.addNode(_node, _data)
      } else {
        if (_data.name !== this.nodeName) {
          this.editNode(_node, _data)
        } else {
          this.nodeName = ''
        }
      }
      this.$nextTick(() => {
        if (_node.isEdit) {
          this.$set(_node, 'isEdit', false)
        }
      })
    },
    handleEdit(_node, _data, flag, tempNode) {
      // 编辑节点
      // 设置编辑状态
      if (!_node.isEdit) {
        this.$set(_node, 'isEdit', true)
      }
      this.treeDraggable = false
      this.nodeName = _data.name
      this.$nextTick(() => {
        // 输入框聚焦
        if (tempNode && tempNode.editFlag && tempNode.editFlag === 'add') {
          if (tempNode && this.$refs[this.treeRef + 'slotTreeInput' + tempNode[this.nodeKey]]) {
            this.$refs[this.treeRef + 'slotTreeInput' + tempNode[this.nodeKey]].$refs.input.focus()
          }
        } else {
          if (_data && this.$refs[this.treeRef + 'slotTreeInput' + _data[this.nodeKey]]) {
            this.$refs[this.treeRef + 'slotTreeInput' + _data[this.nodeKey]].$refs.input.focus()
          }
        }
      })
    },
    // 新增节点
    handleAdd(_node, _data) {
      const obj = JSON.parse(JSON.stringify(this.initParam)) // copy参数
      // 从父组件获取返回值
      // 判断层级
      if (_node.level >= this.MAX_LEVEL) {
        this.$message.warning('当前已达到' + this.MAX_LEVEL + '级，无法新增！')
        return false
      }
      // 展开节点
      if (!_node.expanded) {
        _node.expanded = true
        this.handleNodeExpand(_data)
      }
      /* 2020年4月25日21:33:35 */
      obj.parentId = _data[this.nodeKey] // 父id
      const key = --this.startId
      obj[this.nodeKey] = key // 节点id：逐次递减id
      obj.isEdit = true
      obj.editFlag = 'add'
      // 判断字段是否存在
      if (!_data.children) {
        this.$set(_data, 'children', [])
      }
      // 新增数据
      _data.children.push(obj)
      this.$nextTick(() => {
        const tempNode = this.$refs[this.treeRef].getNode(key)
        this.handleEdit(tempNode, _data, 'add', obj)
      })
      /* 2020年4月25日21:33:35 */

      // this.addNode(_node, _data, obj)
    },
    // 添加顶部节点
    handleAddTop() {
      const obj = JSON.parse(JSON.stringify(this.initParam)) // copy参数
      obj.editFlag = 'add'
      const key = --this.startId
      obj[this.nodeKey] = key // 节点id：逐次递减id
      this.treeData.push(obj)
      this.$nextTick(() => {
        const tempNode = this.$refs[this.treeRef].getNode(key)
        this.handleEdit(tempNode, null, 'add')
      })
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      this.moveNode(draggingNode, dropNode, dropType, this.MAX_LEVEL)
    }
  },
  watch: {
    // defaultCurrentNodeKey(val) {
    //   this.checkedKey = val
    // },
    value() {
      this.valueId = this.value
      this.initHandle()
    },
    filterText(val) {
      this.$refs[this.treeRef].filter(val)
    },
    options(val) {
      this.treeData = JSON.parse(JSON.stringify(val))
      this.$nextTick(() => {
        this.$refs[this.treeRef].setCurrentKey(this.checkedKey)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}

.el-tree-node__label {
  font-weight: normal;
}

.selectInput {
  // padding: 0 5px;
  box-sizing: border-box;
  margin-bottom: 10px;
  /*height: 32px;*/
}

// 显示按钮
.show-btns {
  opacity: 1;
}
/* common end */
.comp-tree {
  flex: auto;
  height: 100%;
  font-size: 12px;
  // 顶部按钮
  .comp-tr-top {
    width: 100px;
    margin-bottom: 2em;
  }
  // 自定义节点
  .comp-tr-node {
    text-align: left;
    // vertical-align: middle;
    width: 100%;
    // label
    .comp-tr-node--name {
      display: inline-block;
      line-height: 40px;
      min-height: 40px;
      // 新增
      // &.is-new {
      // }
    }
    //样式调整 button
    .comp-tr-node--btns {
      right: 0;
      position: absolute;
      margin-top: 10px;
      opacity: 0;
      transition: opacity 0.1s;
      .el-button {
        transform: scale(0.8); // 缩小按钮
        & + .el-button {
          margin-left: -1px;
        }
      }

      .el-dropdown-link {
        padding-right: 10px;
      }
    }
  }
  // 高亮显示按钮
  .is-current {
    & > .el-tree-node__content {
      .comp-tr-node--btns {
        @extend .show-btns;
      }
    }
  }
  // 悬浮显示按钮
  .el-tree-node__content {
    &:hover {
      .comp-tr-node--btns {
        @extend .show-btns;
      }
    }
  }

 /* .el-tree {
    flex: 1;
    overflow-y: auto;
  }*/
}
</style>
<style scoped>
.comp-tree >>> .el-tree-node__content {
  height: 34px;
}

.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}
</style>
